<style lang="scss" scoped>
  .best-moments-block {
    width: 100%;
    overflow: hidden;

    .wrapper {
      height: 495px;
      display: flex;
      align-items: center;
      position: relative;

      @include margin-x(auto);
      width: map_get($container, lg);

      @include media(max, lg) {
        width: map_get($container, md);
        min-height: 298px;
        height: auto;
      }

      @include media(max, md) {
        width: 100%;
        @include padding-x($gutter/2);
      }

      .content {
        z-index: 10;
        max-width: 555px;
        padding-left: 45px;

        @include media(max, lg) {
          max-width: 60%;
          padding-left: 25px;
          position: relative;
          &:after {
            content: "";
            position: absolute;
            top: -100px;
            z-index: -1;
            left: 0;
            right: 0;
            height: 155px;
            background: linear-gradient(180deg, rgba(0, 0, 0, 0.0001) 0%, #000000 100%);
          }
        }

        @include media(max, md) {
          max-width: 100%;
          padding-left: 0;
          margin-top: 225px;
          text-align: left;
        }

        .title {
          @include media(max, lg) {
            margin-bottom: 0;
          }
        }

        .subtitle {
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 28px;
          line-height: 33px;
          margin: 40px 0 20px;

          @include media(max, lg) {
            font-size: 23px;
            margin: 20px 0 10px;
          }

          @include media(max, md) {
            justify-content: flex-start;
          }
        }

        .subtitle-icon {
          width: 55px;
          height: 55px;
          margin-right: 16px;
          background-size: contain;

          @include media(max, md) {
            width: 35px;
            height: 35px;
          }

          [dir=rtl] & {
            margin-right: 0;
            margin-left: 16px;
          }
        }

        .text {
          margin-top: 22px;
          font-size: 18px;
          line-height: 1.6;
          color: #C3C3C3;

          span {
            color: $link-color-blue;
            &:after {
              content: '→';
              font-family: Arial, Helvetica;
              margin-left: 5px;
            }

            &:hover {
              color: $link-hover-color-blue;
            }
            &:active {
              color: $link-active-color-blue;
            }
          }

          @include media(max, lg) {
            margin-top: 16px;
          }
        }
      }

      .image {
        z-index: 5;
        @include position(absolute, 0, -110px);

        @include media(max, lg) {
          text-align: center;
        }

        img {
          width: 547px;
          @include media(max, lg) {
            max-width: 320px;
          }
        }

        @include media(max, md) {
          left: $gutter/2;
          right: $gutter/2;
        }

        [dir=rtl] & {
          @include position(absolute, 0, auto, auto, -110px);

          @include media(max, md) {
            left: $gutter/2;
            right: $gutter/2;
          }
        }
      }
    }
  }
</style>

<template>
  <div class="best-moments-block">
    <div class="wrapper">
      <div class="content">
        <div class="title title_section" v-html="$t('title')"></div>
        <div class="text"
             v-html="$t('text')"
             v-on:click="downloadGameCenter">
        </div>
        <div class="subtitle">
          <div class="subtitle-icon" :style="{backgroundImage: `url(${baseUrl}images/svg/translations.svg)`}"></div>
          {{$t('subtitle')}}
        </div>
        <div class="text" v-html="$t('text2')"></div>
      </div>
      <div class="image">
        <img :src="`${baseUrl}images/blocks/best-moments.png`"/>
      </div>
    </div>
  </div>
</template>

<script>

import { buildDownloadUrl } from '@utils/helpers';

export default {
  name: 'BestMomentsBlock',
  i18n: {
    messages: {
      ru: {
        title: 'Сохраняйте<br> лучшие моменты',
        subtitle: 'Трансляции',
        text:
          'Комбинация ALT+~ позволит получить доступ к&nbsp;медиацентру приложения <a class="link-base" download>Игровой центр</a>'
          + ', где вы сможете делать скриншоты, записывать видео и делиться ими в сообществе.',
        text2:
          'Возможность создания трансляций на популярных видеосервисах',
      },
      en: {
        title: 'Record your best moments',
        subtitle: 'Broadcasts',
        text:
          'Hit ALT + ~ for access to an extensive array of media and capture features via the <a class="link-base" download>GameCenter</a>.',
        text2: 'Ability to create streams on popular video services',
      },
      de: {
        title: 'Zeichne deine besten Momente auf',
        subtitle: 'Streaming',
        text:
          'Die Tastenkombination ALT +~ öffnet das Medienmenü des <a class="link-base" download>GameCenter</a>, wo du Screenshots machen und Videos aufnehmen und sie mit der Community teilen kannst.',
        text2: 'Erstellen von Streams bei populären Videodiensten möglich',
      },
      fr: {
        title: 'Enregistrez vos meilleurs moments',
        subtitle: 'Streaming',
        text:
          'Le raccourci clavier +~ ouvre le menu médias du <a class="link-base" download>GameCenter de</a>, dans lequel vous pouvez faire des captures d\'écran, enregistrer des vidéos et les partager avec la communauté.',
        text2: 'Possibilité de créer des streams sur les services vidéo les plus prisés',
      },
      es: {
        title: 'Graba tus mejores momentos',
        subtitle: 'Retransmisiones',
        text:
          'El atajo de teclado ALT+~ abre el menú multimedia de <a class="link-base" download>GameCenter</a>, donde puedes hacer capturas, grabar vídeos y compartirlos con la comunidad.',
        text2: 'Posibilidad de retransmitir en plataformas de vídeo populares',
      },
      tr: {
        title: 'En iyi anlarını kaydet',
        subtitle: 'Yayında',
        text:
          'Klavye kısayolu ALT+~, ekran görüntüleri alabileceğin, video çekebileceğin ve bunları toplulukla paylaşabileceğin <a class="link-base" download>GameCenter</a> medya menüsünü açar.',
        text2: 'Popüler video hizmetlerinde yayın yapma özelliği',
      },
      pl: {
        title: 'Nagrywaj najlepsze momenty',
        subtitle: 'Streaming',
        text:
        'Skrót klawiaturowy ALT+~ otwiera menu multimediów <a class="link-base" download>Centrum gier</a>, w którym można robić zrzuty ekranu, nagrywać wideo i udostępniać je społeczności.',
        text2: 'Możliwość tworzenia transmisji w popularnych serwisach wideo',
      },
      ar: {
        title: 'سجِّل أفضل لحظاتك',
        subtitle: 'البث',
        text: 'اضغط على ALT+ ~  للوصول إلى مجموعة شاملة من الوسائط والحصول على الميزات عبر <a class="link-base" download>GameCenter</a>.',
        text2: 'القدرة على بث مقاطع فيديو على خدمات الفيديو المشهورة',
      },
    },
  },
  methods: {
    // eslint-disable-next-line
    downloadGameCenter(e) {
      const url = buildDownloadUrl();
      if (e.target.classList.contains('link-base')) {
        // eslint-disable-next-line
        return window.EVA.gc.detectAndDownload('', url)
      }
    },
  },
};

</script>
